import useApiQuery from '@hooks/useApiQuery';
import QueryKeys from '@src/constants/queryKeys';
import { Group } from '@src/types/Group';

const useGroups = () =>
  useApiQuery<Group[]>({
    queryKey: [QueryKeys.groups],
    apiPath: '/user-groups',
    method: 'GET',
    useV2API: true,
  });

export default useGroups;
